var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartDelayed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.848,
    y: 1.513,
    width: 22.305,
    height: 20.974,
    style: {
      stroke: "rgb(255, 165, 0)",
      fill: "rgb(255, 165, 0)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Arial, sans-serif",
      fontSize: 17,
      whiteSpace: "pre"
    },
    x: 6.331,
    y: 17.895
  }, "D"), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: "0.7px"
    },
    x: 32.371,
    y: 7.518
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartDelayed);
export default __webpack_public_path__ + "static/media/DepartDelayed.005ba3b6afefc1b859f6ce6bd299f581.svg";
export { ForwardRef as ReactComponent };